// Navigation utility for handling section navigation
export const navigateToSection = (sectionId) => {
  // If we're on the home page, scroll to section directly
  if (window.location.pathname === "/") {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  } else {
    // Navigate to home page with hash fragment
    window.location.href = `/#${sectionId}`;
  }
};
